import { render, staticRenderFns } from "./PaymentPixSuccess.vue?vue&type=template&id=506b9146&scoped=true"
import script from "./PaymentPixSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentPixSuccess.vue?vue&type=script&lang=js"
import style0 from "./PaymentPixSuccess.vue?vue&type=style&index=0&id=506b9146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b9146",
  null
  
)

export default component.exports